import { render, staticRenderFns } from "./AgentComponent.vue?vue&type=template&id=794cbcba&scoped=true"
import script from "./AgentComponent.vue?vue&type=script&lang=js"
export * from "./AgentComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "794cbcba",
  null
  
)

export default component.exports